<template>
  <v-card class="bg-card rounded-xl px-5 px-md-0">
    <h4 class="text-center text-h4 my-5 primary--text">Turnos</h4>

    <v-row>
      <v-col cols="12" md="6">
        <queue-table title="Prioridad (A)" :items="queues.priorityQueueA" />
        <queue-table title="Particular (A)" :items="queues.normalQueueA" />
      </v-col>

      <v-col cols="12" md="6">
        <queue-table title="Prioridad (B)" :items="queues.priorityQueueB" />
        <queue-table title="Particular (B)" :items="queues.normalQueueB" />
      </v-col>
    </v-row>

    <queue-table
      title="Llamados a caja"
      :items="queues.attentionQueue"
      show-called
      time-field="updatedAt"
    />

    <h4 class="text-center text-h4 mb-3 secondary--text mt-8">Muestras</h4>

    <sampling :items="queues.samplingQueue" />

    <queue-table
      title="Atendidos en muestra"
      :items="queues.samplingAttentionQueue"
      show-called
      station-field="samplingStationId"
    />
  </v-card>
</template>

<script>
import Sampling from './Sampling.vue'
import QueueTable from './QueueTable.vue'

const QUEUE_NAMES = [
  'normalQueueA',
  'normalQueueB',
  'priorityQueueA',
  'priorityQueueB',
  'attentionQueue',
  'waitingQueue',
  'samplingQueue',
  'samplingAttentionQueue',
]

export default {
  components: { Sampling, QueueTable },
  name: 'Unattended',
  data: () => {
    const queues = {}
    QUEUE_NAMES.forEach((name) => {
      queues[name] = []
    })
    return { queues }
  },
  sockets: {
    connect: function () {
      this.loadQueues()
    },
    'queue-updated': function (payload) {
      console.log('queue-updated', payload)
      this.$set(this.queues, payload.queue, payload.items)
    },
  },
  mounted: function () {
    this.loadQueues()
  },
  methods: {
    loadQueues: function () {
      this.$socket.emit('first-load-admin', (response) => {
        console.log('first-load-admin', response)
        if (response?.queues) {
          this.queues = response.queues
        }
      })
    },
  },
}
</script>
